import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

export interface InseminatorBoniterItem {
  id: number;
  regionId: number;
  region?: { id: number; nameRu: string; nameKz: string; nameEn: string } | null;
  subjectTypeRu: string;
  subjectTypeKz: string;
  fullName: string;
  isCattle: boolean;
  startDate: string;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
}

export interface PagedInseminatorBoniterResponse {
  data: InseminatorBoniterItem[];
  totalCount: number;
  page: number;
  size: number;
  totalPages: number;
}

export interface InseminatorBoniterFilters {
  page?: number;
  size?: number;
  regionId?: number;
  searchFullName?: string;
}

export interface CreateInseminatorBoniterRequest {
  regionId: number;
  subjectTypeRu: string;
  subjectTypeKz: string;
  fullName: string;
  isCattle: boolean;
  startDate: string;
  isActive: boolean;
}

function buildQuery(filters: InseminatorBoniterFilters): string {
  const params = new URLSearchParams();
  if (filters.page) params.set('page', String(filters.page));
  if (filters.size) params.set('size', String(filters.size));
  if (filters.regionId) params.set('regionId', String(filters.regionId));
  if (filters.searchFullName) params.set('searchFullName', filters.searchFullName);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

const BASE = API_ENDPOINTS.INSEMINATOR_BONITER.ALL;

export const inseminatorBoniterService = {
  getAll(filters: InseminatorBoniterFilters = {}) {
    return httpClient.get<PagedInseminatorBoniterResponse>(
      API_ENDPOINTS.INSEMINATOR_BONITER.ALL + buildQuery(filters)
    );
  },

  getBoniters(filters: InseminatorBoniterFilters = {}) {
    return httpClient.get<PagedInseminatorBoniterResponse>(
      API_ENDPOINTS.INSEMINATOR_BONITER.BONITERS + buildQuery(filters)
    );
  },

  getInseminators(filters: InseminatorBoniterFilters = {}) {
    return httpClient.get<PagedInseminatorBoniterResponse>(
      API_ENDPOINTS.INSEMINATOR_BONITER.INSEMINATORS + buildQuery(filters)
    );
  },

  getTransplantologists(filters: InseminatorBoniterFilters = {}) {
    return httpClient.get<PagedInseminatorBoniterResponse>(
      API_ENDPOINTS.INSEMINATOR_BONITER.TRANSPLANTOLOGISTS + buildQuery(filters)
    );
  },

  create(body: CreateInseminatorBoniterRequest) {
    return httpClient.post<InseminatorBoniterItem>(BASE, body);
  },

  update(id: number, body: CreateInseminatorBoniterRequest) {
    return httpClient.put<InseminatorBoniterItem>(`${BASE}/${id}`, body);
  },

  delete(id: number) {
    return httpClient.delete(`${BASE}/${id}`);
  },
};
